var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgMoneyspin = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M2.893 6.392A6.81 6.81 0 0 1 9.188 2.19c2.84 0 5.485 1.894 6.422 4.536m-.128 4.882a6.81 6.81 0 0 1-6.294 4.202c-2.84 0-5.453-1.87-6.402-4.482" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M15.998 3.492V6.23a.5.5 0 0 1-.5.5h-2.739M2.378 14.518V11.77a.5.5 0 0 1 .5-.5h2.748m3.562-6.02v1.125m0 5.25v1.125m1.875-6.187H8.252a1.127 1.127 0 1 0 0 2.254h1.387a1.31 1.31 0 1 1 0 2.621H6.938" })] }))); };
export default SvgMoneyspin;
